module.exports = __webpack_public_path__ + "img/points.dac65e7a.png";